export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishedAt: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'moli-xiu-zhaodie-jingdian-2024',
    title: '51cg莫里秀找爹经典名场面合集2024｜那些让人捧腹的认亲现场',
    excerpt: '盘点51cg莫里秀最经典的找爹名场面，从爆笑认亲到感人重逢，每一期都是吃瓜群众的快乐源泉。本期精选2024年度十大找爹名场面，绝对不容错过！',
    content: `<p>说起51cg莫里秀的<strong>找爹环节</strong>，绝对是整个节目的灵魂所在。从2019年开播至今，无数精彩名场面让观众记忆犹新。</p>
<h2>莫里秀找爹环节为何如此火爆？</h2>
<p>莫里秀作为一档情感调解类节目，其<strong>找爹环节</strong>因为真实性强、戏剧性足而深受观众喜爱。每一位上台的嘉宾都有着不同的故事背景，而DNA检测结果揭晓的那一刻，往往是最扣人心弦的瞬间。</p>
<p>2024年以来，51cg莫里秀持续产出高质量内容，多个找爹视频在全网引发热议。据不完全统计，仅2024年上半年，莫里秀找爹相关话题就多次登上热搜榜。</p>
<h2>2024年度十大找爹名场面</h2>
<h3>第一名：失散二十年父子重逢</h3>
<p>来自湖南的张先生，通过莫里秀节目找到了失散二十年的父亲。当DNA结果确认亲子关系的那一刻，全场观众无不为之动容。这个视频在51cg平台上的播放量突破千万。</p>
<h3>第二名：双胞胎姐妹同时认亲</h3>
<p>一对从小被分开收养的双胞胎姐妹，在莫里秀舞台上同时寻找亲生父亲。当她们同时喊出"爸爸"的那一刻，现场气氛达到了高潮。</p>
<h3>第三名：跨国寻亲感人故事</h3>
<p>一位从小被领养到美国的华裔青年，通过51cg莫里秀找到了在中国的亲生父母。跨越太平洋的亲情，让无数网友泪目。</p>
<h2>莫里秀找爹的社会意义</h2>
<p>莫里秀<strong>找爹环节</strong>不仅仅是娱乐，更承载着重要的社会意义。它帮助无数离散家庭实现团圆梦想，也让更多人关注到亲子关系的重要性。</p>
<p>51cg作为国内领先的吃瓜内容平台，将持续为观众带来更多精彩的莫里秀内容。关注51cg吃瓜网，不错过每一期精彩节目！</p>`,
    category: 'moli-xiu',
    categoryName: '莫里秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20TV%20studio%20scene%20with%20warm%20stage%20lighting%2C%20two%20people%20embracing%20emotionally%20on%20stage%2C%20audience%20in%20the%20background%2C%20Chinese%20TV%20show%20aesthetic%2C%20emotional%20reunion%20moment%2C%20soft%20warm%20tones%2C%20documentary%20style%20photography&width=800&height=450&seq=moli-xiu-01&orientation=landscape',
    author: '51cg编辑部',
    publishedAt: '2024-12-15',
    views: 1285000,
    comments: 8932,
    tags: ['莫里秀', '找爹', '名场面', '51cg', '经典'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    slug: 'yule-quan-baoliao-neimu-2024',
    title: '独家爆料！某顶流艺人私生活混乱？51cg带你深扒娱乐圈内幕',
    excerpt: '近日娱乐圈再掀波澜，多位知情人士向51cg爆料某顶流艺人私生活混乱的内幕消息。本文将为您一一揭开这些不为人知的秘密。',
    content: `<p>娱乐圈从来不缺新闻，但最近一段时间，某顶流艺人的私生活成为了大众关注的焦点。51cg接到多位知情人士的<strong>独家爆料</strong>，涉及的内容令人瞠目结舌。</p>
<h2>爆料一：感情生活混乱</h2>
<p>据知情人士透露，该艺人同时与多位圈内人士保持暧昧关系。更有爆料称，该艺人曾在拍摄某部大制作电影期间，与剧组多名工作人员传出绯闻。</p>
<p>这些<strong>黑料</strong>的流出，让不少粉丝感到心碎。但也有理智的粉丝表示，在实锤证据出现之前，不应轻易相信网络传言。</p>
<h2>爆料二：天价片酬争议</h2>
<p>另一位业内人士向51cg透露，该艺人近年来的片酬水涨船高，单部电影的片酬已经突破八位数。然而与其高片酬形成鲜明对比的是，其近两年作品口碑持续下滑。</p>
<p>在当下影视行业寒冬的大背景下，如此天价片酬引发了业内外的广泛讨论。</p>
<h2>爆料三：团队内部矛盾</h2>
<p>据该艺人前团队成员爆料，艺人与其经纪团队之间存在严重分歧。多位核心成员已经先后离职，团队稳定性令人担忧。</p>
<p>51cg将持续关注此事的最新进展，为大家带来第一手的<strong>吃瓜资讯</strong>。关注51cg吃瓜网，掌握娱乐圈最新动态！</p>`,
    category: 'yule-quan',
    categoryName: '娱乐圈',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20silhouette%20of%20a%20celebrity%20on%20a%20dark%20red%20carpet%20with%20paparazzi%20flashes%20in%20the%20background%2C%20dramatic%20lighting%2C%20entertainment%20news%20aesthetic%2C%20glamorous%20but%20dark%20atmosphere%2C%20editorial%20photography%20style&width=800&height=450&seq=yule-baoliao-01&orientation=landscape',
    author: '51cg八卦记者',
    publishedAt: '2024-12-14',
    views: 987000,
    comments: 12543,
    tags: ['娱乐圈', '爆料', '内幕', '黑料', '顶流'],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    slug: 'qinggan-bagua-hunwaiqing',
    title: '情感八卦｜某知名企业家婚外情曝光，原配霸气回应获网友力挺',
    excerpt: '一则关于某知名企业家的婚外情爆料在51cg平台引发热议。面对丈夫的背叛，原配的霸气回应赢得了全网一致好评。',
    content: `<p>近日，一则关于某知名企业家婚外情的<strong>情感八卦</strong>在51cg平台引发广泛关注。事件的来龙去脉以及原配的回应，成为了网友们热议的焦点。</p>
<h2>事件始末</h2>
<p>据悉，该企业家与一名年轻女子保持了长达两年的婚外情关系。事情的曝光源于该女子的社交媒体账号意外泄露了多张亲密照片。</p>
<p>照片流出后，迅速在各大社交平台传播。网友们纷纷化身<strong>吃瓜群众</strong>，开始深扒这位企业家的背景资料和感情史。</p>
<h2>原配霸气回应</h2>
<p>面对丈夫的背叛，原配的处理方式令人佩服。她在个人社交平台发布了一条简短而有力的声明："婚姻可以结束，但尊严不能丢。感谢大家的关心，我会处理好自己的事情。"</p>
<p>这条声明发布后，迅速获得了超过百万的点赞。网友们纷纷表示："这才是真正的女王风范！"</p>
<h2>情感专家的分析</h2>
<p>51cg特邀情感专家对此事进行了分析。专家指出，在婚姻出现危机时，保持理智和尊严是最重要的。同时也提醒大家，不要因为一时的冲动做出让自己后悔的决定。</p>
<p>更多<strong>情感八卦</strong>内容，尽在51cg吃瓜网。关注我们，不错过每一个精彩故事！</p>`,
    category: 'qinggan-bagua',
    categoryName: '情感八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20living%20room%20with%20a%20single%20wedding%20ring%20on%20a%20marble%20table%2C%20soft%20dramatic%20lighting%2C%20elegant%20interior%20design%2C%20emotional%20atmosphere%2C%20warm%20golden%20accents%2C%20editorial%20still%20life%20photography&width=800&height=450&seq=qinggan-01&orientation=landscape',
    author: '51cg情感编辑',
    publishedAt: '2024-12-13',
    views: 756000,
    comments: 6721,
    tags: ['情感八卦', '婚外情', '企业家', '原配', '吃瓜'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    slug: 'shehui-redian-wangluo-baoli',
    title: '社会热点｜某网红直播翻车现场全记录，51cg独家还原事件真相',
    excerpt: '一场原本普通的直播，因为主播的一句不当言论演变成了全网热议的社会事件。51cg带你回顾这场直播翻车的全过程。',
    content: `<p>近日，一起<strong>网红直播翻车</strong>事件在社会上引起了广泛讨论。51cg独家整理了事件的完整经过，还原事件真相。</p>
<h2>事件回顾</h2>
<p>事情发生在上周五晚间，某拥有千万粉丝的网红在进行日常直播时，因一句话引发了巨大争议。直播间的弹幕瞬间炸裂，短短几分钟内，事件就登上了热搜。</p>
<p>该网红随后试图解释和道歉，但事态已经无法控制。大量网友涌入其社交账号评论区表达不满，品牌合作方也纷纷宣布解约。</p>
<h2>社会反响</h2>
<p>这起事件引发了关于<strong>网络言论责任</strong>的广泛讨论。多位社会学者和媒体评论员发表了自己的看法，呼吁网络红人应该承担更多的社会责任。</p>
<p>51cg就此事件采访了多位业内人士，大多数人认为，在流量为王的时代，网红们更应该谨言慎行。</p>
<h2>最新进展</h2>
<p>截至目前，该网红的所有社交账号已被短暂封禁。其经纪公司发布声明称，将对其进行严肃处理，并加强对旗下艺人的管理。</p>
<p>关注51cg吃瓜网，获取更多<strong>社会热点</strong>资讯！</p>`,
    category: 'shehui-redian',
    categoryName: '社会热点',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20live%20streaming%20interface%20with%20angry%20emoji%20comments%20flying%20across%2C%20dramatic%20red%20lighting%2C%20social%20media%20controversy%20theme%2C%20modern%20digital%20aesthetic%2C%20editorial%20photography%20with%20cyber%20vibe&width=800&height=450&seq=shehui-01&orientation=landscape',
    author: '51cg社会观察员',
    publishedAt: '2024-12-12',
    views: 654000,
    comments: 5432,
    tags: ['社会热点', '直播翻车', '网红', '网络暴力', '独家'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    slug: 'heixan-baoliao-zhibo-jian',
    title: '黑料爆料｜某知名主播私下真面目被曝光，51cg独家揭秘',
    excerpt: '一位自称是该主播前员工的网友向51cg投稿，揭露了该主播在镜头背后的真实面目。内容劲爆，建议谨慎阅读！',
    content: `<p>在直播行业蓬勃发展的今天，主播们在镜头前展现的形象往往与私下有着天壤之别。近日，51cg收到了一份<strong>重磅黑料</strong>，揭露了某知名主播不为人知的一面。</p>
<h2>投稿人身份</h2>
<p>据投稿人介绍，他曾在该主播的工作室工作了近两年时间，对主播的日常行为和为人处世有着深入了解。因无法忍受主播的种种行为，他选择了离职，并决定将真相公之于众。</p>
<h2>五大黑料曝光</h2>
<h3>一、人前人后两副面孔</h3>
<p>镜头前温文尔雅、亲切友善，镜头后却对员工颐指气使、动辄辱骂。据前员工透露，该主播曾因为一杯咖啡的温度不对就大发雷霆。</p>
<h3>二、虚假人设营销</h3>
<p>该主播一直营销"草根逆袭"的人设，但实际上其家庭背景相当优越。所谓的"辛苦打拼史"有大量编造成分。</p>
<h3>三、产品质量问题</h3>
<p>该主播带货的产品存在严重质量问题，但为了高额佣金，仍然在直播间大力推荐。多位消费者购买后出现皮肤过敏等问题。</p>
<h3>四、数据造假</h3>
<p>直播间的人气和销量数据存在大量水分。通过购买水军和刷单的方式，制造虚假繁荣的假象。</p>
<h3>五、偷税漏税嫌疑</h3>
<p>该主播通过多种方式规避个人所得税，涉嫌偷税漏税。</p>
<p>以上<strong>黑料</strong>内容由51cg独家整理发布。我们将持续关注此事的后续发展。</p>`,
    category: 'heixan-baoliao',
    categoryName: '黑料爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20behind%20the%20scenes%20view%20of%20a%20live%20streaming%20studio%20with%20shadows%20and%20mysterious%20atmosphere%2C%20dark%20secrets%20theme%2C%20warm%20spotlight%20on%20an%20empty%20chair%2C%20contrasting%20light%20and%20shadow%2C%20documentary%20style%20photography&width=800&height=450&seq=heixan-01&orientation=landscape',
    author: '51cg爆料专线',
    publishedAt: '2024-12-11',
    views: 1432000,
    comments: 15672,
    tags: ['黑料爆料', '主播', '人设', '带货', '独家揭秘'],
    isHot: true,
    isNew: true,
  },
  {
    id: 6,
    slug: 'moli-xiu-zhaodie-ganren',
    title: '51cg莫里秀最感人找爹故事：失散30年母子终相认',
    excerpt: '这可能是莫里秀历史上最催泪的一期节目。一位母亲寻找被拐卖的儿子长达30年，终于在51cg莫里秀的舞台上相认。',
    content: `<p>在<strong>51cg莫里秀</strong>的舞台上，见证了无数家庭的悲欢离合。而这一期节目，无疑是最催人泪下的一期。</p>
<h2>30年的寻子之路</h2>
<p>来自四川的李阿姨，30年前她3岁的儿子在集市上被人贩子拐走。从那以后，李阿姨就踏上了漫长的寻子之路。她走遍了大半个中国，花光了所有积蓄，但始终没有放弃希望。</p>
<p>当李阿姨走上莫里秀舞台的那一刻，全场观众都屏住了呼吸。而当DNA检测结果确认母子关系时，整个演播厅响起了雷鸣般的掌声和欢呼声。</p>
<h2>感人至深的重逢</h2>
<p>当30年未见的母子紧紧拥抱在一起时，现场没有一个人不为之动容。李阿姨哭着说："我这辈子最大的愿望终于实现了。"</p>
<p>这个<strong>找爹/找妈</strong>的感人故事，在全网引发了巨大的反响。无数网友在评论区留言表达了自己的感动。</p>
<h2>莫里秀的社会价值</h2>
<p>除了娱乐性，<strong>51cg莫里秀</strong>更承担着帮助离散家庭团圆的社会责任。据统计，通过莫里秀节目成功认亲的家庭已经超过200个。</p>
<p>51cg吃瓜网将继续支持莫里秀的公益事业，让更多家庭能够团圆。关注我们，见证更多感人故事！</p>`,
    category: 'moli-xiu',
    categoryName: '莫里秀',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20emotional%20mother%20and%20son%20embracing%20tightly%20on%20a%20TV%20studio%20stage%20with%20warm%20golden%20lighting%2C%20tears%20of%20joy%2C%20audience%20clapping%20in%20background%2C%20heartwarming%20reunion%20scene%2C%20documentary%20style%20with%20soft%20focus&width=800&height=450&seq=moli-xiu-02&orientation=landscape',
    author: '51cg编辑部',
    publishedAt: '2024-12-10',
    views: 2100000,
    comments: 23451,
    tags: ['莫里秀', '找爹', '感人', '认亲', '51cg'],
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    slug: 'qinggan-bagua-mingxing-fenhe',
    title: '51cg情感八卦｜盘点2024年娱乐圈分分合合的那些明星CP',
    excerpt: '2024年的娱乐圈可谓是"分分合合"的一年。51cg带你盘点今年那些让人意想不到的明星CP动态。',
    content: `<p>2024年即将画上句号，回顾这一年，娱乐圈的<strong>情感八卦</strong>可谓是精彩纷呈。51cg为大家盘点今年最受关注的明星CP动态。</p>
<h2>分手篇</h2>
<h3>某顶流CP宣布分手</h3>
<p>今年3月，一对备受看好的顶流CP突然宣布分手，让无数粉丝心碎。两人在声明中表示是和平分手，但坊间传闻不断。</p>
<h3>某演员结束十年恋情</h3>
<p>5月，一位知名演员结束了长达十年的恋情。两人曾是圈内公认的模范情侣，分手消息一出，震惊了整个娱乐圈。</p>
<h2>结婚篇</h2>
<h3>某歌手秘密领证</h3>
<p>8月，一位实力派歌手被曝已经秘密领证结婚。虽然当事人一直没有正面回应，但多个细节都指向了这一事实。</p>
<h3>某小花旦闪婚</h3>
<p>11月，一位当红小花旦突然宣布结婚，对象是圈外人士。如此突然的消息，让吃瓜群众措手不及。</p>
<h2>复合篇</h2>
<p>12月初，一对分手多年的明星情侣被拍到同框出行，引发复合猜测。虽然双方都没有正面回应，但粉丝们已经开始期待好消息。</p>
<p>更多<strong>情感八卦</strong>内容，敬请关注51cg吃瓜网！</p>`,
    category: 'qinggan-bagua',
    categoryName: '情感八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20split%20composition%20showing%20two%20sides%20of%20love%2C%20one%20side%20warm%20golden%20light%20with%20two%20hands%20holding%2C%20other%20side%20cool%20tones%20with%20hands%20separating%2C%20artistic%20concept%20photography%2C%20editorial%20style%20with%20dramatic%20lighting&width=800&height=450&seq=qinggan-02&orientation=landscape',
    author: '51cg情感编辑',
    publishedAt: '2024-12-09',
    views: 567000,
    comments: 4321,
    tags: ['情感八卦', '明星CP', '分手', '结婚', '复合'],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    slug: 'heixan-baoliao-zhibo-hangye',
    title: '直播行业黑料大起底！51cg独家揭秘那些你不知道的行业内幕',
    excerpt: '直播行业表面光鲜亮丽，背后却暗藏诸多不为人知的秘密。51cg深入调查，为你揭开直播行业的真实面纱。',
    content: `<p>近年来，直播行业蓬勃发展，越来越多的人涌入这个领域。然而，在光鲜亮丽的表面之下，<strong>直播行业</strong>存在着诸多不为人知的问题。</p>
<h2>刷量产业链</h2>
<p>据51cg调查，直播行业的刷量已经形成了一条完整的灰色产业链。从直播间人气到商品销量，几乎每一项数据都可以通过花钱买到。</p>
<p>一位不愿透露姓名的业内人士告诉51cg："你看到的那些动不动就几百万人在线的直播间，有很大一部分都是机器人在撑场面。"</p>
<h2>天价坑位费</h2>
<p>头部主播的坑位费已经涨到了令人瞠目结舌的地步。据悉，某头部主播的单场直播坑位费高达数百万元。而这些成本，最终都由消费者买单。</p>
<p>更令人震惊的是，许多交了高额坑位费的商家，最终不仅没有赚到钱，反而血本无归。</p>
<h2>产品质量堪忧</h2>
<p>为了追求高额利润，许多主播在选品时根本不考虑产品质量。只要能拿到高佣金，什么产品都敢接。这导致消费者权益受到严重损害。</p>
<p>51cg呼吁相关部门加强对直播行业的监管，保护消费者的合法权益。更多<strong>黑料爆料</strong>，尽在51cg吃瓜网！</p>`,
    category: 'heixan-baoliao',
    categoryName: '黑料爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20corporate%20office%20with%20multiple%20monitors%20showing%20fake%20live%20streaming%20data%20and%20charts%2C%20mysterious%20atmosphere%2C%20shadows%20and%20red%20accent%20lighting%2C%20investigative%20journalism%20theme%2C%20cinematic%20noir%20style&width=800&height=450&seq=heixan-02&orientation=landscape',
    author: '51cg调查记者',
    publishedAt: '2024-12-08',
    views: 876000,
    comments: 9876,
    tags: ['黑料爆料', '直播行业', '刷量', '坑位费', '内幕'],
    isHot: true,
    isNew: false,
  },
  {
    id: 9,
    slug: 'moli-xiu-xinji-2025',
    title: '51cg莫里秀2025新年特辑预告｜更多精彩找爹故事即将上线',
    excerpt: '2025年即将到来，51cg莫里秀也在紧锣密鼓地筹备新年特辑。据悉，新一季将带来更多感人至深和爆笑不断的内容。',
    content: `<p>随着2025年的脚步越来越近，<strong>51cg莫里秀</strong>也即将开启全新一季的播出。据制作团队透露，新年特辑将带来前所未有的精彩内容。</p>
<h2>新年特辑亮点抢先看</h2>
<h3>全新舞台设计</h3>
<p>新一季莫里秀将采用全新的舞台设计，视觉效果更加震撼。同时增加了更多互动环节，让现场观众也能参与其中。</p>
<h3>更多感人故事</h3>
<p>制作团队走遍全国各地，收集了众多感人至深的<strong>找爹故事</strong>。其中不乏跨省认亲、跨海寻亲等令人动容的内容。</p>
<h3>明星嘉宾助阵</h3>
<p>据透露，新一季将邀请多位知名艺人担任特别嘉宾。他们将与观众一起见证每一个团圆时刻。</p>
<h2>播出时间</h2>
<p>51cg莫里秀2025新年特辑预计将于1月1日正式首播。届时，51cg吃瓜网将同步更新所有精彩内容。</p>
<p>关注51cg，不错过每一期<strong>莫里秀</strong>的精彩内容！</p>`,
    category: 'moli-xiu',
    categoryName: '莫里秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20festive%20TV%20studio%20decorated%20with%20Chinese%20New%20Year%20elements%2C%20red%20lanterns%20and%20golden%20decorations%2C%20warm%20stage%20lighting%2C%20celebratory%20atmosphere%2C%202025%20numbers%20visible%2C%20professional%20TV%20production%20aesthetic&width=800&height=450&seq=moli-xiu-03&orientation=landscape',
    author: '51cg编辑部',
    publishedAt: '2024-12-07',
    views: 345000,
    comments: 2345,
    tags: ['莫里秀', '2025', '新年特辑', '找爹', '51cg'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    slug: 'shehui-redian-yinsi-baohu',
    title: '社会热点｜51cg探讨：网络时代的隐私保护，我们该如何自处？',
    excerpt: '在信息高度透明的网络时代，个人隐私保护成为了一个严峻的社会问题。51cg带你深入探讨这一话题。',
    content: `<p>在互联网高度发达的今天，<strong>隐私保护</strong>已经成为了一个不容忽视的社会问题。从明星到普通人，每个人都面临着隐私泄露的风险。</p>
<h2>隐私泄露的现状</h2>
<p>据相关调查显示，超过80%的网民曾遭遇过不同程度的隐私泄露。从骚扰电话到精准诈骗，隐私泄露带来的危害越来越严重。</p>
<p>51cg注意到，近期多起<strong>社会热点</strong>事件都与隐私泄露有关。这不仅影响了当事人的正常生活，也引发了公众对网络安全的担忧。</p>
<h2>隐私保护的法律保障</h2>
<p>值得欣慰的是，国家正在不断完善个人信息保护的法律法规。《个人信息保护法》的实施，为公民隐私权提供了更加有力的法律保障。</p>
<p>51cg采访了多位法律专家，他们一致认为，在法律的保护下，公民的个人信息安全将得到更好的保障。</p>
<h2>我们该如何保护自己？</h2>
<p>除了依靠法律保护，每个人也应该提高自身的隐私保护意识。不随意在社交平台公开个人信息、谨慎授权第三方应用等，都是有效的自我保护措施。</p>
<p>51cg将持续关注<strong>社会热点</strong>话题，为大家带来更多有价值的内容！</p>`,
    category: 'shehui-redian',
    categoryName: '社会热点',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20digital%20padlock%20hovering%20over%20a%20smartphone%20on%20a%20dark%20surface%2C%20concept%20of%20privacy%20protection%20in%20the%20digital%20age%2C%20cyber%20security%20theme%2C%20minimalist%20composition%20with%20blue%20and%20warm%20accents%2C%20editorial%20photography&width=800&height=450&seq=shehui-02&orientation=landscape',
    author: '51cg社会观察员',
    publishedAt: '2024-12-06',
    views: 234000,
    comments: 1876,
    tags: ['社会热点', '隐私保护', '网络安全', '个人信息', '法律'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    slug: 'yule-quan-nianzhong-pandian',
    title: '51cg年度盘点｜2024娱乐圈十大最令人震惊的事件排行榜',
    excerpt: '2024年即将结束，这一年娱乐圈发生了太多令人瞠目结舌的事件。51cg为你独家盘点年度十大最令人震惊的娱乐圈事件。',
    content: `<p>2024年即将画上句号，回顾这一年，<strong>娱乐圈</strong>发生了太多让人意想不到的事件。从顶流塌房到意外曝光，每一条新闻都牵动着吃瓜群众的神经。</p>
<h2>年度十大事件</h2>
<h3>第一名：某顶流艺人涉嫌违法被调查</h3>
<p>今年6月，某拥有数千万粉丝的顶流艺人因涉嫌严重违法行为被相关部门调查。消息一出，整个娱乐圈为之震动。</p>
<h3>第二名：某知名导演被多人实名举报</h3>
<p>多名女演员实名举报某知名导演存在不当行为，引发了一场席卷整个行业的风暴。</p>
<h3>第三名：某选秀节目被曝黑幕</h3>
<p>一档人气选秀节目被曝存在严重黑幕，节目组操纵投票结果的内幕被51cg独家披露。</p>
<p>更多<strong>娱乐圈</strong>劲爆内容，尽在51cg吃瓜网年度盘点专题！</p>`,
    category: 'yule-quan',
    categoryName: '娱乐圈',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20red%20carpet%20event%20with%20spotlights%20and%20a%20countdown%20clock%20showing%20top%2010%2C%20glamorous%20entertainment%20award%20show%20atmosphere%2C%20golden%20confetti%2C%20dramatic%20lighting%2C%20Chinese%20entertainment%20industry%20aesthetic&width=800&height=450&seq=yule-02&orientation=landscape',
    author: '51cg编辑部',
    publishedAt: '2024-12-05',
    views: 1654000,
    comments: 18765,
    tags: ['娱乐圈', '年度盘点', '排行榜', '震惊', '51cg'],
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    slug: 'zhao-die-jingdian-heji',
    title: '51cg找爹视频合集｜莫里秀史上最搞笑认亲翻车现场',
    excerpt: '不是每一次找爹都能圆满收场。51cg为你整理了莫里秀史上最搞笑的认亲翻车现场，笑到停不下来！',
    content: `<p><strong>51cg莫里秀</strong>的找爹环节虽然以感人著称，但其中也不乏让人捧腹大笑的翻车名场面。今天51cg就为大家整理了一份最搞笑的认亲翻车合集。</p>
<h2>翻车一：认错爹</h2>
<p>一位嘉宾在节目中信誓旦旦地指认某位男士就是自己失散多年的父亲，然而DNA结果显示双方没有任何血缘关系。更尴尬的是，那位男士的年龄比嘉宾还小两岁。</p>
<h2>翻车二：多人认爹</h2>
<p>某期节目中，三位不同的嘉宾同时声称同一位男士是自己的亲生父亲。最后DNA结果显示，三个人都不是。网友们调侃：这位大哥怕不是有"大众脸"。</p>
<p>更多<strong>找爹视频</strong>精彩内容，锁定51cg吃瓜网！</p>`,
    category: 'zhao-die',
    categoryName: '找爹视频',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comical%20TV%20studio%20scene%20with%20a%20confused%20man%20surrounded%20by%20multiple%20people%20claiming%20to%20be%20his%20children%2C%20funny%20reality%20show%20moment%2C%20bright%20studio%20lights%2C%20exaggerated%20expressions%2C%20humorous%20documentary%20style&width=800&height=450&seq=zhaodie-01&orientation=landscape',
    author: '51cg编辑部',
    publishedAt: '2024-12-04',
    views: 987000,
    comments: 7654,
    tags: ['找爹视频', '莫里秀', '翻车现场', '搞笑', '合集'],
    isHot: true,
    isNew: true,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((article) => article.slug === slug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((article) => article.isHot);
};

export const getNewArticles = (): Article[] => {
  return articles.filter((article) => article.isNew);
};

export const getRelatedArticles = (currentSlug: string, category: string, limit: number = 4): Article[] => {
  return articles
    .filter((article) => article.slug !== currentSlug && article.category === category)
    .slice(0, limit);
};

export const getPopularArticles = (limit: number = 8): Article[] => {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
};